export class UserSummary {
    public id: string;
    public persona: string;
    public personaId: string;
    public role: string;
    public roleId: string;
    public email: string;
    public name: string;
    public isLead: boolean;
    public isAdmin: boolean;
    public isUnavailable: boolean;
    public capacity: number | null;
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/users/user-summary.model.ts